/* eslint-disable */
import Knotenlast from './Knotenlast'
import Stablast from './Stablast'

export default class Lastfall{
    /**
     * Klasse für Lastfälle
     * @param {*} list 
     * @param {*} name 
     * @param {*} color 
     */
    constructor(list, name, color){
        this.name = name || 'neuer Lastfall'
        this.Color = color || 'blue'
        this.Knotenlastliste = []
        this.Stablastliste = []
        this.Ergebnisvektor = null
        this.Schnittkräfte = []
        this.MaxWerte = {N: 0, Q: 0, M: 0, W:0}
        this.Auflagerreaktionen = []
        this.list = list || null
    }
    get number() {
        if(this.list) return this.list.indexOf(this)+1
        else return null
    }

    get Berechnet() { return this.Ergebnisvektor ?  true : false}

    set Berechnet(value) { 
        if (!value) {
            this.Ergebnisvektor = null
            this.Auflagerreaktionen = []
        }
    }

// Knotenlasten
    newKnotenlast(fX, fY, M, Knotenliste){
        const cKnotenlast = new Knotenlast(null, fX, fY, M, Knotenliste, this)
        this.addKnotenlast(cKnotenlast)
        return cKnotenlast
    }   
    
    addKnotenlast(knotenlast){
        knotenlast.list = this.Knotenlastliste
        this.Knotenlastliste.push(knotenlast)
        console.log('Knotenlast Nr.' + knotenlast.number + ' wurde hinzugefügt.')
    }
    
    editKnotenlast(knotenlast, fX, fY, M, Knotenliste){
        //Knotenverknüpfungen löschen
        knotenlast.release_bindings()
        //knotenlast.Knotenliste.forEach(cKnoten => {knotenlast.delete_Knotenverknüpfung(cKnoten)});
        //Werte Ändern
        knotenlast.fX = fX
        knotenlast.fY = fY
        knotenlast.M = M
        knotenlast.Lastfall = this
        //Knotenverknüfungen erstellen
        Knotenliste.forEach(cKnoten =>{knotenlast.add_Knotenverknüpfung(cKnoten)})
        this.addKnotenlast(knotenlast)
    }

    deleteKnotenlast(knotenlast){
        if (this.Knotenlastliste.indexOf(knotenlast)==-1) return console.log('Knotenlast nicht in Liste')
        this.Knotenlastliste.splice(this.Knotenlastliste.indexOf(knotenlast),1)
        console.log('Knotenlast wurde gelöscht.')
    }
    
    deleteKnotenlast_byNumber(number){

    }

// Stablasten
    //constructor(list, p1, p2, Orientierung, Bezugslänge, Stabliste, Lastfall){
    newStablast(p1, p2, Orientierung, Bezugslänge, Stabliste){
        const cStablast = new Stablast(null, p1, p2, Orientierung, Bezugslänge, Stabliste, this)
        this.addStablast(cStablast)
        return cStablast
    }

    addStablast(stablast){
        stablast.list = this.Stablastliste
        this.Stablastliste.push(stablast)
        console.log('Stablast Nr.' + stablast.number + ' wurde hinzugefügt.')
    }

    editStablast(stablast, p1, p2, Orientierung, Bezugslänge, Stabliste){
        //Verknüpfungen löschen
        stablast.release_bindings()
        //Werte ändern
        stablast.p1 = p1
        stablast.p2 = p2
        stablast.Orientierung = Orientierung
        stablast.Bezugslänge = Bezugslänge
        stablast.Lastfall = this
        //Stabverknüpfungen erstellen
        Stabliste.forEach(cStab =>{stablast.add_Stabverknüpfung(cStab)})
        this.addStablast(stablast)
    }

    deleteStablast(stablast){
        if (this.Stablastliste.indexOf(stablast)==-1) return console.log('Stablast nicht in Liste')
        this.Stablastliste.splice(this.Stablastliste.indexOf(stablast),1)
        console.log('Stablast wurde gelöscht.')        
    }

    deleteStablast_byNumber(number){
        
    }
}